import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Tag } from "lucide-react";

import { addOffer } from "../../../redux/offer/action";
import CouponForm, { emptyCouponValues } from "./CouponForm";
import "../../Common/FormShell/FormShell.css";

const AddOffers = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (payload) => {
    dispatch(addOffer(payload, setLoading, navigate));
  };

  return (
    <div className="nb-page">
      <div className="nb-topbar">
        <button
          type="button"
          className="nb-topbar__back"
          onClick={() => navigate("/offerlist")}
        >
          <ArrowLeft size={14} aria-hidden="true" />
          Coupons
        </button>
        <span className="nb-topbar__sep">/</span>
        <span className="nb-topbar__current">New coupon</span>
      </div>

      <div className="nb-hero" style={{ maxWidth: 840, margin: "0 auto", padding: "28px 24px 0" }}>
        <span className="nb-hero__eyebrow">
          <Tag size={11} aria-hidden="true" />
          Marketing
        </span>
        <h1 className="nb-hero__title">Create coupon</h1>
        <p className="nb-hero__sub">
          Set the code and discount, choose what it applies to and who can use
          it, then schedule when it's live.
        </p>
      </div>

      <CouponForm
        initialValues={emptyCouponValues}
        onSubmit={handleSubmit}
        loading={loading}
        submitLabel="Create coupon"
      />
    </div>
  );
};

export default AddOffers;
